import { Text, Flex, Image, Button } from "@chakra-ui/react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { useMobileBreakpoint } from "../../utils/useBreakpoints";
import { FunnelComponentProps } from "../../components/funnel/types";
import { t } from "i18next";

export function HolidayBundleCongratsBody({
  onSuccess,
  customCongratsImage,
}: FunnelComponentProps & {
  customCongratsImage?: string;
}) {
  const isMobile = useMobileBreakpoint();

  return (
    <Flex flexDirection="column" alignItems="center" width="100%">
      <Flex marginY="24px" px="24px" flexDirection="column">
        <Text
          variant="onboardingTitle"
          textAlign="center"
          fontSize="24px"
          mb="8px"
        >
          {t("screens.holidayBundle.welcomeToGlobalComix")}
        </Text>
        <Text
          variant="onboardingTitle"
          textAlign="center"
          fontSize="24px"
          mb="8px"
        >
          {t("screens.holidayBundle.youJustEarned")}
        </Text>
      </Flex>
      <Image
        src={
          customCongratsImage ??
          `${window.gc.global.assets_url}/static/images/web-ui/holiday-bundle/holiday_bundle_gifts_2.png`
        }
        width="100%"
        height="auto"
        aspectRatio="512/300"
        maxW="607px"
        marginBottom="24px"
      />
      <Flex
        flexDirection="column"
        gap="24px"
        width="100%"
        px={isMobile ? "24px" : "48px"}
      >
        <Button
          gc-testing-id="btnOnboardingStartReading"
          variant="primary"
          size="lg"
          onClick={() => onSuccess({})}
          width="100%"
        >
          Continue
        </Button>
      </Flex>
      <DotLottieReact
        src={`${window.gc.global.assets_url}/static/images/web-ui/stars_confetti.json`}
        style={{
          position: "absolute",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          pointerEvents: "none",
        }}
        autoplay
      />
    </Flex>
  );
}
